var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_out)?_c('a',{staticClass:"link",attrs:{"href":_vm.to,"target":"_blank","rel":"nofollow"}},[_vm._t("default")],2):_c('div',{staticClass:"link",on:{"click":_vm.toLink}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }